module.exports = __webpack_public_path__ + "img/due_diligence.7d7f4cb1.svg";